'use client';

import { type PostSessionPayloadDTO } from '@hc-frontend/services';
import { useEffect } from 'react';

import updateSession from '../../actions/update-session-action/update-session-action';

interface Properties {
  name: string;
  timeout: number;
}

function waitForCookie({ name, timeout }: Properties): Promise<string | null> {
  return new Promise<null | string>((resolve) => {
    const t0 = performance.now();
    const loopInterval = setInterval(detectCookie, 200);

    /**
     * Function to detect cookie inside the interval
     */
    function detectCookie() {
      const t1 = performance.now();
      if (t1 - t0 <= timeout) {
        const cookie = document.cookie
          .split('; ')
          .find((row) => row.startsWith(name));
        if (cookie) {
          clearInterval(loopInterval);
          resolve(cookie.split('=')[1]);
        }

        return null;
      } else {
        clearInterval(loopInterval);
        resolve(null);
      }
    }
  });
}

export default function FacebookPixelClient() {
  useEffect(() => {
    Promise.all([
      // Attempt to retrieve Facebook cookies for 10 seconds, after that
      // send the available values to Session Manager
      waitForCookie({ name: '_fbp', timeout: 10_000 }),
      waitForCookie({ name: '_fbc', timeout: 10_000 }),
    ]).then(([fbp, fbc]) => {
      const keys = [];
      if (fbp) {
        keys.push({
          Name: '_fbp',
          Value: fbp,
        });
      }
      if (fbc) {
        keys.push({
          Name: '_fbc',
          Value: fbc,
        });
      }
      if (keys.length > 0) {
        updateSession({
          TrafficContext: {
            Keys: keys,
          },
        } as PostSessionPayloadDTO); // UserContext will be injected in the server action
      }
    });
  }, []);

  return null;
}
